import "./App.css";
import DashBoard from "./pages/DashBoard/DashBoard";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/layout/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllBlog from "./pages/AllBlogs/AllBlog";
import CreateBlog from "./pages/CreateBlog/CreateBlog";
import Query from "./pages/Query/Query";
import Login from "./pages/login/Login";
import EditBlog from "./pages/EditBlog/EditBlog";
import JobPost from "./pages/JobPost/JobPost";

import { useEffect } from "react";
import store from "./store";
import { LoadUser } from "./actions/userActions";
import NewsLetter from "./pages/newsletter/NewsLetter";
import CreateNewsLetter from "./pages/createNewsLetter/CreateNewsLetter";
import Profile from "./pages/profile/Profile";
import Authentication from "./components/authentication/Authentication";
import AllCaseStudy from "./pages/caseStudy/AllCaseStudy";
import CreateCaseStudy from "./pages/createCaseStudy/CreateCaseStudy";
import EditCaseStudy from "./pages/editcasestudy/EditCaseStudy";
import AllPageMetaData from "./pages/allPageMetaData/AllPageMetaData";
import CreateMetaData from "./pages/createMetaData/CreateMetaData";
import EditMetaData from "./pages/editMetaData/EditMetaData";
import AllJob from "./pages/JobPost/AllJob";
import Contact from "./pages/Contact/Contact";
import {
  CONTACT_ACCESS_ROLES,
  CONTENT_ACCESS_ROLES,
  FULL_ACCESS_ROLES,
  JOB_ACCESS_ROLES,
} from "./utils/roleAccess";

function App() {
  useEffect(() => {
    store.dispatch(LoadUser);
  }, []);
  return (
    <div className="App">
      <ToastContainer toastStyle={{ backgroundColor: "white" }} />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Authentication allowedRoles={FULL_ACCESS_ROLES}>
                <Layout>
                  <DashBoard />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/allblogs"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                {" "}
                <Layout>
                  <AllBlog />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/createblog"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <CreateBlog />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/query"
            element={
              <Authentication allowedRoles={FULL_ACCESS_ROLES}>
                <Layout>
                  <Query />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/all-contact"
            element={
              <Authentication allowedRoles={CONTACT_ACCESS_ROLES}>
                <Layout>
                  <Contact />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/jobpost"
            element={
              <Authentication allowedRoles={JOB_ACCESS_ROLES}>
                {" "}
                <Layout>
                  <JobPost />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/alljobdata"
            element={
              <Authentication allowedRoles={JOB_ACCESS_ROLES}>
                {" "}
                <Layout>
                  <AllJob />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/editblog/:id"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                {" "}
                <Layout>
                  <EditBlog />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/newsLetter-user"
            element={
              <Authentication allowedRoles={FULL_ACCESS_ROLES}>
                {" "}
                <Layout>
                  <NewsLetter />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/Create-newsLetter"
            element={
              <Authentication allowedRoles={FULL_ACCESS_ROLES}>
                <Layout>
                  <CreateNewsLetter />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/profile"
            element={
              <Authentication>
                <Layout>
                  <Profile />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/all-case-study"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <AllCaseStudy />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/create-case-study"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <CreateCaseStudy />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/update-case-study/:id"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <EditCaseStudy />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/allpage-meta-data"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <AllPageMetaData />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/create-metadata"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <CreateMetaData />
                </Layout>
              </Authentication>
            }
          />
          <Route
            path="/edit-metadata/:id"
            element={
              <Authentication allowedRoles={CONTENT_ACCESS_ROLES}>
                <Layout>
                  <EditMetaData />
                </Layout>
              </Authentication>
            }
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
